// The row of child name pills (Felix | Freddie) at the top of the Kids tab, and since 3 Oct
// at the top of Earnings check (Alan: "Use the same child name pills as the top of the Kids
// tab... Reuse that component rather than copying it"). One component, so the two can never
// drift apart.
//
// R-D (Aug 2026, punch-list 5): the design's side-by-side child pills. Horizontally
// scrollable for bigger families; hidden-on-device children stay selectable (parent mode
// ignores visibility) but show dimmed, labelled "hidden".
//
// `onAdd` is the Kids tab's "+" pill; leave it out and there is no "+" (Earnings check).
// `testId` keeps the two placements apart for a locator while both are on screen: the Kids
// tab sits behind the Earnings check window.
export function KidChips({ profiles, activeId, onSelect, hiddenIds, onAdd, testId = "kid-chips" }) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-0.5 -mx-1 px-1" data-testid={testId}>
      {profiles.map((p) => {
        const activeChip = p.id === activeId;
        const hidden = hiddenIds?.includes(p.id);
        return (
          <button
            key={p.id}
            onClick={() => onSelect(p.id)}
            className={`flex-shrink-0 rounded-lg px-4 py-2 text-sm font-bold whitespace-nowrap ${activeChip ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-600"} ${hidden ? "opacity-50" : ""}`}
          >{p.name}{hidden ? <span className="font-normal opacity-70"> · hidden</span> : ""}</button>
        );
      })}
      {onAdd && <button onClick={onAdd} aria-label="Add child" className="flex-shrink-0 rounded-lg px-3.5 py-2 text-sm font-bold bg-slate-100 text-slate-900 border border-slate-200">＋</button>}
    </div>
  );
}
